export default {
    allContents: null,
    unauthPageContents: null,
    newsResources: null,
    faResources: null,
    stResources: null,
    abResources: null
}



// WEBPACK FOOTER //
// ./src/store/dynamiccontents/state.js